import ClientCreate from "components/ClientCreate";
import ClientEditPopup from "components/ClientEditPopup";
import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Container,
  Form,
  Header,
  Message,
  Table,
} from "semantic-ui-react";
import { cognitoUserPoolId } from "services/api";
import {
  clientBoardingActivity,
  createClient,
  fetchClientList,
  getEnvList,
} from "services/custom-features";

const ClientBoarding = () => {
  const [clientEnv, setClientEnv] = useState("");
  const [clientList, setClientList] = useState([]);

  const [errors, setErrors] = useState({});

  const [open, setOpen] = useState(false);
  const [isSelectedClientEnv, setIsSelectedClientEnv] = useState(true);

  const [totalEnvOptions, setTotalEnvOptions] = useState([]);

  const defaultWebhookMap = JSON.stringify({
    defaultUrl: {
      "url": "",
      "method": "POST"
    },
    updateFieldTask: {},
    updateWorklog: {},
    bulkUploadTask: {},
    startTravelTime: {},
    stopTravelTime: {},
    cancelTravelTime: {},
    onsiteTravelTime: {},
    releaseTravelTime: {},
    updateFacilityRequest: {},
    takeFieldTask: {},
    takefieldtaskandtravel: {},
    createFieldTask: {}
  }, null, 2);

  const [formData, setFormData] = useState({
    clientName: "",
    clientEmail: "",
    env: "",
    webhookAuthType: "",
    webhookAuthId: "",
    webhookAuthSecret: "",
    webhookContentType: "",
    webhookGrantType: "",
    webhookScope: "",
    webhookTokenUrl: "",
    webhooksMap: defaultWebhookMap,
  });

  const [notification, setNotification] = useState({
    responseType: "",
    showMessage: false,
    message: "",
  });

  useEffect(() => {
    async function fetchAndSetEnv() {
      const totalEnvOptions = ((await getEnvList()) || []).map((item) => ({
        key: item,
        value: item,
        text: item,
      }));
      console.log("Env list for client management section", totalEnvOptions);
      setTotalEnvOptions(totalEnvOptions);
    }
    fetchAndSetEnv();
  }, []);

  const createClientOnboarding = async () => {
    let {
      clientName,
      clientEmail,
      env,
      webhookAuthType,
      webhookAuthId,
      webhookAuthSecret,
      webhookContentType,
      webhookGrantType,
      webhookScope,
      webhookTokenUrl,
      webhooksMap,
    } = formData;
    const newErrors = {};

    if (!clientName) {
      newErrors.clientName = "Client name is required**";
    }

    if (!clientEmail) {
      newErrors.clientEmail = "Client email is required**";
    }

    if (!env) newErrors.env = "Environment is required";

    if (!webhooksMap) {
      newErrors.webhooksMap = "Webhooks JSON is required";
    } else {
      try {
        JSON.parse(webhooksMap);
      } catch (e) {
        newErrors.webhooksMap = "Invalid JSON format";
      }
    }

    if (webhookAuthType) {
      if (!webhookAuthId)
        newErrors.webhookAuthId = "Webhook Username is required**";
      if (!webhookAuthSecret)
        newErrors.webhookAuthSecret = "Webhook Password is required**";
      if (webhookAuthType === "OAUTH2" && !webhookTokenUrl)
        newErrors.webhookTokenUrl = "Webhook Token URL is required**";
    }

    if (!webhookAuthType) {
      webhookAuthId = "";
      webhookAuthSecret = "";
      webhookContentType = "";
      webhookGrantType = "";
      webhookTokenUrl = "";
      webhookScope = "";
    }
    if (Object.keys(newErrors).length === 0) {
      const response = await createClient({
        ...formData,
        userPoolId: cognitoUserPoolId,
      });

      setNotification({
        status: response.status,
        showMessage: true,
        message: response.message,
      });

      setFormData({
        clientName: "",
        clientEmail: "",
        env: "",
        webhookAuthType: "",
        webhookAuthId: "",
        webhookAuthSecret: "",
        webhookContentType: "",
        webhookGrantType: "",
        webhookScope: "",
        webhookTokenUrl: "",
        webhooksMap: defaultWebhookMap,
      });
      setErrors({});
    } else {
      // Display validation errors
      setErrors(newErrors);
    }
  };

  const showClientListByEnv = async () => {
    try {
      if (clientEnv) {
        const response = await fetchClientList(clientEnv);
        setNotification({
          status: response.status,
          showMessage: true,
          message: response.message,
        });
        setIsSelectedClientEnv(true);
        setClientList(response.data);
      } else {
        setIsSelectedClientEnv(false);
      }
    } catch (error) {
      setNotification({
        status: "500",
        showMessage: true,
        message: error.message,
      });
    }
  };

  const handleDismiss = () => {
    setNotification({
      status: "",
      showMessage: false,
      message: "",
    });
  };
  const [selectedClientForEdit, setSelectedClientForEdit] = useState(null);

  const handleClientEdit = (client) => {
    setSelectedClientForEdit(client);
    setOpen(!open);
  };

  const handleClientActivity = async (client) => {
    try {
      const clientBoardingStatus = await clientBoardingActivity({
        clientEnv,
        clientId: client.client_id,
        clientStatus: !client.active,
      });
      const clientListResponse = await fetchClientList(clientEnv);
      setNotification({
        status: clientBoardingStatus.status,
        showMessage: true,
        message: clientBoardingStatus.message,
      });
      setIsSelectedClientEnv(true);
      setClientList(clientListResponse.data);
    } catch (error) {
      setNotification({
        status: "500",
        showMessage: true,
        message: error.message || "Error while updating client activity status",
      });
    }
  };

  return (
    <>
      <Container fluid style={{ padding: "2em" }}>
        {notification.showMessage ? (
          <Message
            onDismiss={handleDismiss}
            header={notification.message}
            color={notification.status === 200 ? "green" : "red"}
          />
        ) : null}
        <Header as="h1">Client Onboarding</Header>
        <ClientCreate
          setNotification={setNotification}
          formData={formData}
          setFormData={setFormData}
          totalEnvOptions={totalEnvOptions}
          createClientOnboarding={createClientOnboarding}
          errors={errors}
          isEdit={false}
        />
        <div style={{ paddingTop: "4em" }}>
          <Header as="h1">Client List</Header>
          <Form onSubmit={showClientListByEnv} style={{ display: "flex" }}>
            <Form.Group>
              <Form.Dropdown
                name="clientEnv"
                required
                label="Environment"
                placeholder="environment"
                search
                selection
                value={clientEnv}
                options={totalEnvOptions}
                onChange={(e, { value }) => {
                  setClientEnv(value);
                  setIsSelectedClientEnv(true);
                }}
                error={
                  !isSelectedClientEnv
                    ? {
                        content: "Please select the env",
                        pointing: "above",
                      }
                    : null
                }
              ></Form.Dropdown>
            </Form.Group>
            <Form.Button
              color="blue"
              style={{ margin: "25px 10px" }}
              content="Submit"
            />
          </Form>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Client Name</Table.HeaderCell>
                <Table.HeaderCell>Client Email</Table.HeaderCell>
                <Table.HeaderCell>Client Url</Table.HeaderCell>
                <Table.HeaderCell>Action</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            {clientList.length ? (
              <Table.Body>
                {clientList.map((client) => (
                  <Table.Row key={client.client_id}>
                    <Table.Cell>{client.client_name}</Table.Cell>
                    <Table.Cell>{client.client_email}</Table.Cell>
                    <Table.Cell>
                      <Fragment>
                        {client.active && (
                          <Button
                            style={{ padding: "9px 14px" }}
                            color="blue"
                            content="Edit"
                            onClick={() => handleClientEdit(client)}
                          />
                        )}
                        <Button
                          style={{ padding: "9px 14px" }}
                          color={client.active ? "red" : "green"}
                          content={client.active ? "Deactivate" : "Activate"}
                          onClick={() => handleClientActivity(client)}
                        />
                      </Fragment>
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            ) : (
              <p
                style={{
                  textAlign: "center",
                  fontWeight: "normal",
                  fontSize: "24px",
                  padding: "15px 0",
                }}
              >
                No Data available!
              </p>
            )}
          </Table>
        </div>
      </Container>
      <ClientEditPopup
        handler={handleClientEdit}
        open={open}
        setNotification={setNotification}
        totalEnvOptions={totalEnvOptions}
        client={selectedClientForEdit}
        clientEnv={clientEnv}
      />
    </>
  );
};

export default ClientBoarding;
